import { useContext } from 'react';

import { PermissionsAlertContext } from 'features/permissions/context/PermissionsAlertContext';

export default function usePermissionsAlert() {
  const context = useContext(PermissionsAlertContext);

  if (!context) throw new Error('PermissionsAlertContext must be inside provider');

  return context;
}
